import $ from "jquery";
import userSelects from "./userSelects";
import {updatePage} from "./page-summary";
import {updateUserData} from "./page-register-warranty";

export default function () {
    document.querySelector('#registrationFormModal').addEventListener('show.bs.modal', (e) => {
        let $body = $(e.target).find('.modal-body');
        $body.find('input:not(:checkbox)').each(function () {
            $(this).val(window.$registrationData.user[$(this).attr('name')]);
        });
        $body.find('select').each(function () {
            let value = window.$registrationData.user[$(this).data('name')];
            if (typeof window.$registrationData.user[$(this).data('name')] === "undefined") {
                value = "";
            }
            $(this).html('<option value="' + value + '" selected>' + value + '</option>');
            $(this).change().trigger('select2:select');
        });
        /*if (typeof window.$registrationData.user.marketing !== "undefined") {
            $body.find('input[name=marketing]').prop('checked', true);
        }*/
        userSelects();
    })

    $('body').on('click', 'button:submit', function () {
        let elem = $('#registrationFormModal .modal-body').get(0);

        //save product before clone
        let data = new FormData();
        let inputElements = $(elem).find("input,select,textarea").serializeArray();
        for (var key in inputElements) {
            data.append($("[name=" + inputElements[key].name + "]").attr("name"), inputElements[key].value);
        }

        /*if ($("input[name='marketing']").is(':checked')) {
            data.append('marketing', true);
        }*/

        $(elem).find('.invalid-feedback').remove();
        $(elem).find('.is-invalid').removeClass('is-invalid');

        $.ajax({
            url: updateUserUrl,
            method: "POST",
            data: data,
            processData: false,
            contentType: false,
            success: function (result) {
                $('#registrationFormModal .btn-close').click();
                if ($('body').hasClass('summary')) {
                    $("#summary-data").replaceWith('<div id="loading" class="text-center">\n' +
                        '<span class="loader mb-8"></span>\n' +
                        '</div>');
                    updatePage();
                }
                window.$registrationData = result;
                if ($('body').hasClass('products')) {
                    updateUserData();
                }
            },
            error: function (xhr) {
                let elem = $('#registrationFormModal .modal-body').get(0);

                let response = JSON.parse(xhr.responseText);
                if (typeof response['errors'] !== "undefined") {
                    for (var key in response['errors']) {
                        $(elem).find('[name=' + key + ']:eq(0)').addClass('is-invalid').after(
                            '<div id="validation' + key + 'Feedback" class="invalid-feedback">' +
                            response['errors'][key] +
                            '</div>'
                        );
                    }
                }
            }
        });
    });
}
